import { render } from "./ProductTagMgmt.vue?vue&type=template&id=0a1599e1&scoped=true"
import script from "./ProductTagMgmt.vue?vue&type=script&lang=js"
export * from "./ProductTagMgmt.vue?vue&type=script&lang=js"

import "./ProductTagMgmt.vue?vue&type=style&index=0&id=0a1599e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1599e1"]])

export default __exports__